import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Styles.
 */

export const StyledRuleEditorSidebarContainerDiv = styled.div`
  margin-left: 24px;
  width: 268px;
  min-width: 268px;
`;

export const StyledRuleEditorSidebarSection = styled.div<{$color?: string}>`
  padding: 15px;
  background-color: ${({$color, theme}) => $color || theme.greys.shade10};
  border-radius: 14px;
  margin-bottom: 15px;
  line-height: 1.5;
`;

export const StyledRuleEditorSidebarSectionTitle = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: auto auto auto;
  grid-template-areas: 'icon title info';
  align-items: self-start;
  justify-content: start;
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.bold};
`;

export const StyledRuleEditorSidebarSectionContent = styled.div`
  padding-left: 16px;
`;

export const StyledRuleEditorSidebarExpressionSection = styled.div`
  ul {
    padding-left: 0;
    list-style: none;

    > li:not(:last-of-type) {
      margin-bottom: 12px;
    }
  }
`;

export const StyledRuleEditorSidebarSpacer = styled.div`
  height: 5px;
`;

export const StyledRuleEditorSidebarSectionList = styled.ul`
  padding-left: 28px;
  margin-bottom: 0;
`;

export const StyledRuleEditorSidebarSectionListHighlight = styled.span`
  color: ${(p) => p.theme.palette.blue.shade40};
  font-weight: ${fontWeights.semibold};

  &:hover {
    color: ${(p) => p.theme.palette.blue.shade50};
  }
`;
